import ApiBuilder, { updateVendorProfilePayload } from "@/api/ApiBuilder";
import { createAsyncThunk, isRejectedWithValue } from "@reduxjs/toolkit";



interface getdefaultArgs {
    pathparams?: String ;
    token?: string;
    callback?: (response: any) => void; // Optional callback
}


interface updateVendorProfileArg {
    payload: updateVendorProfilePayload; // Replace `any` with a proper interface if available
    callback?: (response: any) => void; // Optional callback
}


export const getVendorProfile = createAsyncThunk<any, getdefaultArgs>(
    "profile/getVendorProfile",
    async ({ token, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getVendorProfile(token);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Login failed";

            return rejectWithValue(errorMessage);
        }
    }
);


export const getCustomerByPhone = createAsyncThunk<any, getdefaultArgs>(
    "profile/getCustomerByPhone",
    async ({ pathparams, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getCustomerByPhone(pathparams);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Fetch Failed ";

            return rejectWithValue(errorMessage);
        }
    }
);



export const updateVendorProfile = createAsyncThunk<any, updateVendorProfileArg>(
    "vendor/updateVendorProfile",
    async ({ payload, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.updateVendorProfile(payload);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Update Vendor Profile Failed";

            return rejectWithValue(errorMessage);
        }
    }
);


export const vendorDashboardDetails = createAsyncThunk<any, getdefaultArgs>(
    "vendor/vendorDashboardDetails",
    async ({ callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.vendorDashboardDetails();
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Dashboard details fetch failed";

            return rejectWithValue(errorMessage);
        }
    }
);

export const createVendorFundAccount = createAsyncThunk<any, getdefaultArgs>(
    "vendor/createVendorFundAccount",
    async ({ callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.createVendorFundAccount();
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Create Fund account failed";

            return rejectWithValue(errorMessage);
        }
    }
);



export const validateVendorBankAccount = createAsyncThunk<any, getdefaultArgs>(
    "vendor/validateVendorBankAccount",
    async ({ callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.validateVendorBankAccount();
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Bank account verification failed";
            return rejectWithValue(errorMessage);
        }
    }
);